import { render, staticRenderFns } from "./CardEditor.vue?vue&type=template&id=3fb2d752&scoped=true"
import script from "./CardEditor.vue?vue&type=script&lang=js"
export * from "./CardEditor.vue?vue&type=script&lang=js"
import style0 from "./CardEditor.vue?vue&type=style&index=0&id=3fb2d752&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb2d752",
  null
  
)

export default component.exports